import React, { useState } from 'react';
import seoConfig from '../../config/seo.json';

const FAQSection = ({ agentKey }) => {
  const [openIdx, setOpenIdx] = useState(null);
  const agent = seoConfig.pages[agentKey];
  if (!agent?.faqs?.length) return null;
  const faqs = agent.faqs;

  return (
    <section style={{ padding: '80px 0', background: '#f8fafc', borderTop: '1px solid rgba(148,163,184,0.16)' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 24px' }}>
        <h2 style={{ fontSize: '2rem', fontWeight: 800, color: '#0f172a', marginBottom: '8px', letterSpacing: '-0.03em' }}>
          Frequently Asked Questions
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#64748b', marginBottom: '48px' }}>
          {agent.title.replace(' | Eagentix', '')} — common questions answered.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              style={{
                borderRadius: '16px',
                border: '1px solid rgba(148,163,184,0.2)',
                background: 'white',
                overflow: 'hidden',
                boxShadow: openIdx === idx ? '0 8px 32px rgba(0,113,227,0.08)' : '0 2px 8px rgba(15,23,42,0.04)',
                transition: 'box-shadow 0.2s ease',
              }}
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                style={{
                  width: '100%',
                  padding: '20px 24px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '16px',
                  textAlign: 'left',
                }}
                aria-expanded={openIdx === idx}
              >
                <span style={{ fontSize: '1rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.4 }}>
                  {faq.question}
                </span>
                <span style={{
                  flexShrink: 0,
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  background: openIdx === idx ? '#0071e3' : '#f1f5f9',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                }}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={openIdx === idx ? 'white' : '#64748b'} strokeWidth="2.5" strokeLinecap="round">
                    {openIdx === idx
                      ? <line x1="5" y1="12" x2="19" y2="12" />
                      : <><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></>
                    }
                  </svg>
                </span>
              </button>
              {openIdx === idx && (
                <div style={{ padding: '0 24px 20px', color: '#475569', fontSize: '0.97rem', lineHeight: 1.75 }}>
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
